module.exports = __webpack_public_path__ + "static/media/trumpetExplore.eab27e64.png";